import { Component, Input, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { FullNamePipe } from '@common/pipe/full-name.pipe';
import { PaymentStatus, PaymentType } from '@modules/universal-billing/accounting/payments/payment.enum';
import { PaginatorModule } from '@primeng/paginator';
import { SkeletonModule } from '@primeng/skeleton';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { BasicForm } from '@shared/components/classes/basic.form';
import { Payment } from '@modules/universal-billing/accounting/payments/payments.interfaces';
import { DefaultService } from '@common/references/default.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-payment-view',
  standalone: true,
  imports: [
    TranslatePipe,
    FullNamePipe,
    PaginatorModule,
    SkeletonModule,
    ReactiveFormsModule,
    DatePipe,
  ],
  templateUrl: './payment-view.component.html',
  styleUrl: './payment-view.component.scss'
})
export class PaymentViewComponent extends BasicForm<Payment> {
  @Input() payment: any;
  renter: any
  _defaultService: DefaultService<Payment>;
  form: FormGroup;
  paymentTypes: PaymentType[] = [PaymentType.CREDIT_CARD, PaymentType.CASH, PaymentType.BANK_TRANSFER];
  paymentStatuses: PaymentStatus[] = [PaymentStatus.PAID, PaymentStatus.PENDING, PaymentStatus.UNPAID, PaymentStatus.CANCELED];
  public showSkeleton = signal(false);

  constructor(private fb: FormBuilder) {
    super();
    this.form = this.fb.group({})
  }

}
